<template>
  <div class="tabs-menu">
    <div class="tabs-menu__inner">
      <div
        v-for="(name, id, index) in items"
        :key="id"
        class="tabs-menu__button"
        :class="{
          'tabs-menu__button--active': activeItem === id,
          'tabs-menu__button--first': index === 0,
          'tabs-menu__button--last': index === Object.keys(items).length - 1
        }"
        :data-item="id"
        :title="getTabTooltip(id)"
        @click="$emit('activeTab', id)">
        {{ name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabsMenu",
  props: {
    items: {
      type: Object,
      default: () => {}
    },
    activeItem: {
      type: String
    },
    showKeyboardShortcuts: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isMac() {
      return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    },
    modifierKey() {
      return this.isMac ? '⌘' : 'Ctrl';
    }
  },
  methods: {
    getTabTooltip(tabId) {
      if (!this.showKeyboardShortcuts) {
        return '';
      }

      const tabKeys = Object.keys(this.items);
      const tabIndex = tabKeys.indexOf(tabId);

      if (tabIndex === -1) {
        return '';
      }

      return `Switch tabs: ${this.modifierKey} + Shift + < or >`;
    }
  }
};
</script>

<style lang="scss">
</style>
